export default __webpack_public_path__ + "static/media/SupportDocumentation.6b0c777c.svg";